import { columnMenuProps } from "src/components/customColumnMenu";
import DataTable from "src/components/dataTable";
import { LoadingPanel } from "src/components/loadingPanel";
import { useHistory } from "react-router-dom";
import { GridColumn as Column } from "@progress/kendo-react-grid";
import { getUserCredential } from "src/lib/cookies";
import useApproverDashboardApi from "../index.hook";
import { DEFAULT_SORT } from "src/constants/grid";
import { forwardRef, memo, useCallback, useEffect, useImperativeHandle, useMemo, useState } from "react";
import { getEndDate, getfilterDataString, getStartDate } from "src/utils/utils";
import { CellRender, RowRender } from "src/components/renderers";
const ProviderListBox = forwardRef((props, ref) => {
  const history = useHistory();
  const cookiesData = getUserCredential();

  const { startDate, endDate } = props;

  useImperativeHandle(ref, () => ({
    resetFilter: onClearFilter,
  }));

  const [list, Action] = useApproverDashboardApi();
  const {
    data,
    columns,
    dataCount,
    isAPICalling,
    setData,
    setAPICallingState,
    isRefreshLoading,
    isContractLoading,
    providerSubColumn,
  } = list;
  const [columnData, setColumnData] = useState([]);
  const [gridColumns, setGridColumns] = useState([]);
  const [subGridColumns, setSubGridColumns] = useState([]);
  const [filterData, setFilterData] = useState({
    isSort: false,
    isFilter: false,
    data: "",
    in_sort_number: DEFAULT_SORT.number,
    in_sort_order: DEFAULT_SORT.order,
  });
  const [filterField, setFilterField] = useState({
    logic: "and",
    filters: [],
  });
  const [sortField, setSortField] = useState([]);

  const [refreshTableKey, setRefreshTableKey] = useState({
    refreshData: 0,
  });

  const getInFilter = () => {
    return filterData.isFilter ? filterData.data : null;
  };

  const getInSortNumber = () => {
    return filterData.isSort ? filterData.in_sort_number : DEFAULT_SORT.number;
  };

  const getInSortOrder = () => {
    return filterData.isSort ? filterData.sort_order : DEFAULT_SORT.order;
  };

  const getGridData = useCallback(
    async (payload) => {
      const res = await Action.fetchGetProvidersForApprover(payload);
    },
    [Action]
  );

  const handleColumnMenu = (columnMenuData, isFilter, isSort, filterObj) => {
    if (isSort) {
      setSortField(columnMenuData);
    } else {
      setFilterField(filterObj);
    }

    let index = 1;
    if (data.length > 0 && columnMenuData[0] !== undefined) {
      const sortStr =
        "provider_mstr_key|provider_name|provider_user_key|contract_type_mstr_key|contract_type|pending_rate|approval_rate|rejected_rate|total_earnings".split(
          "|"
        );

      index = sortStr.findIndex((x) => x === columnMenuData[0].field) + 1;
    }
    const filterString = isFilter ? getfilterDataString(columnMenuData, gridColumns) : filterData.data;

    isFilter = false;
    if (filterString !== "") {
      isFilter = true;
    }

    let sortDir = filterData.isSort && columnMenuData.length ? filterData.sort_order : DEFAULT_SORT.order;
    let sortNumber = filterData.isSort && columnMenuData.length ? filterData.in_sort_number : DEFAULT_SORT.number;

    isSort = !columnMenuData.length ? false : filterData.isSort;

    if (columnMenuData[0] !== undefined && columnMenuData[0].dir !== undefined) {
      isSort = true;
      sortDir = columnMenuData[0].dir.toUpperCase();
      sortNumber = index;
    }

    setFilterData({
      ...filterData,
      isFilter: isFilter,
      isSort: isSort,
      data: filterString,
      in_sort_number: sortNumber,
      sort_order: sortDir,
    });
  };

  const onClearFilter = () => {
    setAPICallingState(true);
    setGridColumns([]);
    setSortField([]);
    setFilterField({ logic: "and", filters: [] });
    setFilterData({
      ...filterData,
      data: "",
      isFilter: false,
      isSort: false,
      in_sort_number: DEFAULT_SORT.number,
      in_sort_order: DEFAULT_SORT.order,
    });
  };

  useEffect(() => {
    const dataVal = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_approver_mstr_key: cookiesData.out_user_id.toString(),
      in_filter: getInFilter(),
      in_sort_number: getInSortNumber(),
      in_sort_order: getInSortOrder(),
      in_load_type: "grid-reload",
    };

    if (startDate) {
      dataVal.in_start_date = startDate ? getStartDate(startDate) : null;
    }
    if (endDate) {
      dataVal.in_end_date = endDate ? getEndDate(endDate) : null;
    }
    if ((startDate && endDate) || filterData.isFilter || filterData.isSort) {
      const timer = setTimeout(() => {
        getGridData(dataVal);
      }, 500);

      return () => clearTimeout(timer); // Cleanup previous timeout
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData, startDate, endDate]);

  useEffect(() => {
    if (columns.length > 0) {
      setColumnData(columns);
      setGridColumns(columns);
    }
  }, [columns]);

  // Custom Status Cell Renderer Component
  const RequestCountCell = (props) => {
    const pendingCount = props.dataItem.pending_count;
    const provider_mstr_key = props.dataItem.provider_mstr_key;
    const contract_name_mstr_key = props.dataItem.contract_name_mstr_key;

    const handleRequestCount = () => {
      history.push({
        pathname: "/approver_pay_request_overview",
        state: {
          status: "PENDING",
          defaultKeys: { provider_mstr_key, contract_name_mstr_key },
          startDate,
          endDate,
        },
      });
    };

    return (
      <td className="k-table-td requestCount" style={{ textAlign: "center", verticalAlign: "middle" }}>
        <span className="requestCount" onClick={() => handleRequestCount()}>
          {pendingCount}
        </span>
      </td>
    );
  };

  const createRateCellHandler = (rateField, status) => {
    return (props) => (
      <td className="k-table-td" style={{ textAlign: "center", verticalAlign: "middle" }}>
        <span>{props.dataItem?.[rateField]}%</span>
      </td>
    );
  };

  const AmountCell = (props) => {
    const total_earnings = props.dataItem.total_earnings;
    return (
      <td className="k-table-td">
        <span>$ {total_earnings.toFixed(2)}</span>
      </td>
    );
  };
  const NameCell = (props) => {
    const { dataItem, field } = props;
    return (
      <td className="k-table-td" title={dataItem[field]}>
        <span>{dataItem[field]}</span>
      </td>
    );
  };

  const colRenders = (columnList) => {
    return columnList.map((col, idx) => {
      return col.show && col.title !== "" ? (
        <Column
          {...columnMenuProps(col)}
          key={idx}
          sortable={col.field === "provider_name" || col.field === "contract_type" ? true : false}
          width={col.field === "provider_name" || col.field === "contract_type" ? 120 : 50}
          cell={
            col.field === "pending_count"
              ? RequestCountCell
              : col.field === "approval_rate"
                ? createRateCellHandler("approval_rate", "APPROVED")
                : col.field === "pending_rate"
                  ? createRateCellHandler("pending_rate", "PENDING")
                  : col.field === "rejected_rate"
                    ? createRateCellHandler("rejected_rate", "REJECTED")
                    : col.field === "total_earnings"
                      ? AmountCell
                      : NameCell
          }
          resizable={true}
          editable={false}
          format={col.format}
          className="cursorIcon"
        />
      ) : (
        false
      );
    });
  };

  const customRowRender = (tr, props) => (
    <RowRender originalProps={props} tr={tr} style={{ cursor: "pointer" }} onRowClick={handleRowDoubleClick} />
  );
  const customCellRender = (td, props) => {
    return (
      <CellRender
        navigatable={true}
        originalProps={props}
        td={td}
        updateActBtn="grid-incell-update"
        cancelActBtn="grid-incell-cancel"
      />
    );
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  let GroupColumn = colRenders(gridColumns);

  const expandChange = async (event) => {
    data
      .filter((d) => d.selected === true)
      .map((item) => {
        item.selected = false;
        return 0;
      });

    let mstrKey = event.dataItem.rowId;
    let masterTableData = data.slice();

    let index = masterTableData.findIndex((d) => d.rowId === mstrKey);

    masterTableData
      .filter((x) => x.expanded === true)
      .map((item) => {
        item.expanded = false;
        return 0;
      });

    if (!event.value || event.dataItem.expanDataItem) {
      if (event.value === true && refreshTableKey === mstrKey) {
        setRefreshTableKey(0);
      } else {
        masterTableData[index].expanded = event.value;
        masterTableData[index].selected = true;
        setData(masterTableData);
        return;
      }
    }

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_approver_mstr_key: cookiesData.out_user_id.toString(),
      in_provider_mstr_key: event.dataItem.provider_mstr_key,
      in_contract_type_mstr_key: event.dataItem.contract_type_mstr_key,
      in_start_date: startDate ? getStartDate(startDate) : null,
      in_end_date: endDate ? getEndDate(endDate) : null,
      in_sort_number: DEFAULT_SORT.number,
      in_sort_order: DEFAULT_SORT.order,
      in_load_type: "grid-reload",
    };

    let expanDataItem = await Action.fetchGetContractForApprover(requestBody);
    masterTableData[index].expanDataItem = expanDataItem;
    masterTableData[index].expanded = event.value;
    masterTableData[index].selected = true;
    console.log(masterTableData, "master table data");
    setData(masterTableData);
  };

  useEffect(() => {
    if (providerSubColumn.length > 0) {
      setSubGridColumns(providerSubColumn);
    }
  }, [providerSubColumn]);

  const DetailComponent = memo((props) => {
    const subGridHandleDoubleClick = (props) => {
      console.log("subgrid props", props.dataItem);
      const { provider_mstr_key, contract_name_mstr_key, contract_type_mstr_key } = props.dataItem;
      history.push({
        pathname: "/approver_pay_request_overview",
        state: {
          status: "ALL",
          defaultKeys: { provider_mstr_key, contract_name_mstr_key, contract_type_mstr_key },
          startDate,
          endDate,
        },
      });
    };

    const handleRateCell = (dataItem, status) => {
      //console.log(dataItem, 'dataItem Props')
      const { provider_mstr_key, contract_type_mstr_key } = dataItem;
      history.push({
        pathname: "/approver_pay_request_overview",
        state: {
          status: status,
          defaultKeys: { provider_mstr_key, contract_type_mstr_key },
          startDate,
          endDate,
        },
      });
    };

    const createRateCellHandler = (rateField, status) => {
      return (props) => (
        <td
          className="k-table-td"
          style={{ textAlign: "center", verticalAlign: "middle" }}
          onClick={() => handleRateCell(props.dataItem, status)}
        >
          <span style={{ cursor: "pointer" }}>{props.dataItem?.[rateField]}%</span>
        </td>
      );
    };

    const subAmountCell = (props) => {
      const total_earnings = props.dataItem.total_earnings;
      return (
        <td className="k-table-td cursorIcon">
          <span>$ {total_earnings.toFixed(2)}</span>
        </td>
      );
    };

    const subColRenders = (columnList) => {
      return columnList.map((col, idx) => {
        return col.show && col.title !== "" ? (
          <Column
            {...columnMenuProps(col)}
            key={idx}
            sortable={false}
            width={
              col.field === "specialty_name" || col.field === "contract_name"
                ? 90
                : col.field === "total_earnings" || col.field === "position_type_name"
                  ? 70
                  : 60
            }
            cell={
              col.field === "approval_rate"
                ? createRateCellHandler("approval_rate", "APPROVED")
                : col.field === "pending_rate"
                  ? createRateCellHandler("pending_rate", "PENDING")
                  : col.field === "rejected_rate"
                    ? createRateCellHandler("rejected_rate", "REJECTED")
                    : col.field === "total_earnings"
                      ? subAmountCell
                      : NameCell
            }
            resizable={true}
            editable={false}
            format={col.format}
            className="cursorIcon"
          />
        ) : (
          false
        );
      });
    };

    let SubGroupColumn = useMemo(() => subColRenders(subGridColumns), [subGridColumns]);

    return props.dataItem ? (
      <div className="providerlist-inner-cell-data">
        {props.dataItem.expanDataItem ? (
          <DataTable
            isAPICalling={isContractLoading}
            initialLoading={true}
            data={props.dataItem.expanDataItem}
            id="providerSub-request-grid"
            customColumn={SubGroupColumn}
            columns={subGridColumns}
            isPagination={false}
            gridHeight="100%"
            //gridHeight={props.dataItem?.expanDataItem?.length === 0 ? '10vh' : '30vh'}
            isResizable={true}
            isSortable={false}
            scrollable="scrollable"
            dataCount={props.dataItem?.expanDataItem?.length}
            dataItemKey="contract_name_mstr_key"
            onRowClick={subGridHandleDoubleClick}
          />
        ) : (
          false
        )}
      </div>
    ) : (
      false
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const collapseRows = () => {
    console.log("testing clooaspse rows");
    data
      .filter((d) => d.selected === true)
      .map((item) => {
        item.selected = false;
        return 0;
      });

    const newData = data.filter((d) => d.expanded === true);

    if (newData.length) {
      newData.map((item) => {
        item.expanded = false;
        return 0;
      });
      setData([...data]);
    }
  };

  const handleRowDoubleClick = (props, event) => {
    const target = event.target;
    if (target && (target.closest(".k-i-plus") || target.closest(".k-i-minus"))) {
      event.stopPropagation();
    } else {
      const { provider_mstr_key, contract_type_mstr_key } = props?.originalProps?.dataItem;
      console.log(startDate, "==>", endDate);
      history.push({
        pathname: "/approver_pay_request_overview",
        state: {
          status: "ALL",
          defaultKeys: { provider_mstr_key, contract_type_mstr_key },
          startDate,
          endDate,
        },
      });
    }
  };

  return (
    <div className="providerList">
      <div className="providerList_header">
        <div>Provider List</div>
      </div>
      <div className="providerList-body rowhoverdisable" style={{ position: "relative" }}>
        {isAPICalling && <LoadingPanel gridId="provider-request-grid" />}
        {gridColumns.length > 0 ? (
          <DataTable
            isAPICalling={isAPICalling}
            initialLoading={true}
            data={data}
            id="provider-request-grid"
            customColumn={GroupColumn}
            columns={gridColumns}
            isPagination={false}
            gridHeight="50vh"
            isResizable={true}
            isSortable={true}
            scrollable="scrollable"
            rowRender={customRowRender}
            cellRender={customCellRender}
            dataCount={dataCount}
            dataItemKey="rowId"
            handleColumnMenu={handleColumnMenu}
            onRowClick={handleRowDoubleClick}
            initialFilter={filterField}
            initialSort={sortField}
            reorderable={true}
            onClearFilter={onClearFilter}
            expandChange={expandChange}
            DetailComponent={DetailComponent}
            collapseRows={collapseRows}
            setRefreshTableKey={setRefreshTableKey}
          />
        ) : null}
      </div>
    </div>
  );
});
export default ProviderListBox;
